<!--
 * @Descripttion: 
 * @Author: xutao
 * @Date: 2020-09-24 18:26:03
 * @LastEditors: xutao
 * @LastEditTime: 2020-12-30 10:38:05
 * @FilePath: \yunjiactivity-h5\src\pages\vipRecall\components\blessRewards.vue
-->
<template>
  <div class="wrapper">
    <div class="bless-rewards-wrapper">
      <div class="reward-bg"></div>
      <div class="reward-content">
        <div
          class="reward-item"
          v-for="(item, index) in rewardData"
          v-bind:key="index"
        >
          <span class="item-price">
            <span
              class="item-price-text"
              v-if="item.rewardType == REWARD_TYPE_ENUM.COUPON"
              >¥</span
            >
            <span v-text="getValueFunc(item)"></span>
          </span>
          <div class="item-content">
              <span class="item-title" v-text="getTitleFunc(item)"></span>
              <span class="item-desc" v-text="getUseScopeFunc(item)"></span>
            </div>
        </div>
      </div>
    </div>
    <template v-if="showMask">
      <div class="reward-modal-mask"></div>
      <div class="reward-modal">
        <div class="reward-modal-content">
          <div
            class="reward-item"
            v-for="(item, index) in rewardData"
            v-bind:key="index"
          >
            <span class="item-price">
              <span
                class="item-price-text"
                v-if="item.rewardType == REWARD_TYPE_ENUM.COUPON"
                >¥</span
              >
              <span v-text="getValueFunc(item)"></span>
            </span>
            <div class="item-content">
              <span class="item-title" v-text="getTitleFunc(item)"></span>
              <span class="item-desc" v-text="getUseScopeFunc(item)"></span>
            </div>
          </div>
        </div>
        <p class="reward-modal-tip">{{countDownTime}}s后关闭</p>
      </div>
    </template>
  </div>
</template>

<script>
/**
 * 奖励类型
 */
const REWARD_TYPE_ENUM = {
  SCORE: 0,
  COUPON: 1,
  COIN: 2,
  VIRTUAL_COIN: 3
}
/**
 * 使用范围
 */
const USE_SCOPE_ENUM = {
  ALL: 0, // 全场通用(除跨境商品)  
  SPE_CATEGORY: 1, // 指定类目
  SPE_GOODS: 2, // 指定商品
  SPE_COUPON: 3, // 指定品牌团 
  SPE_SUBJECT: 4 // 指定专题
}
export default {
  name: 'blessReward',
  data() {
    return {
      REWARD_TYPE_ENUM,
      showMask: true, // 是否展示弹窗
      countDownTime: 2 // 弹窗显示倒计时
    }
  },
  props: {
    code: {
      type: Number,
      default: 0
    },
    rewardData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    
  },
  mounted() {
    this.startCountDown()
  },
  methods: {
    /**
     * 根据奖励类型获取价值
     */
    getValueFunc(item) {
      let value = 0
      switch (item.rewardType) {
        case REWARD_TYPE_ENUM.SCORE:
          value = `${item.rewardValue || 0}`
          break
        case REWARD_TYPE_ENUM.COUPON:
          value = `${item.detail && item.detail.value || 0}`
          break
        case REWARD_TYPE_ENUM.COIN:
        case REWARD_TYPE_ENUM.VIRTUAL_COIN:
          value = `${item.rewardValue || 0}`
          break
      }
      return value
    },
    /**
     * 根据奖励类型获取标题
     */
    getTitleFunc(item) {
      let title = ''
      switch (item.rewardType) {
        case REWARD_TYPE_ENUM.COUPON:
          title = item.detail && item.detail.name || ''
          // title = `${item.rewardValue}元无门槛优惠券`;
          break
        case REWARD_TYPE_ENUM.SCORE:
          title = `${item.rewardValue}积分`
          break
        case REWARD_TYPE_ENUM.COIN:
        case REWARD_TYPE_ENUM.VIRTUAL_COIN:
          title = `${item.rewardValue}云币`
          break
      }
      return title
    },
    /**
     * 获取适用范围
     */
    getUseScopeFunc(item) {
      let content = ''
      let useScope = ''
      switch (item.rewardType) {
        case REWARD_TYPE_ENUM.SCORE:
          useScope = USE_SCOPE_ENUM.SPE_GOODS
          break
        case REWARD_TYPE_ENUM.COUPON:
          useScope = item.detail && item.detail.useScope
          break
        case REWARD_TYPE_ENUM.COIN:
          useScope = USE_SCOPE_ENUM.SPE_GOODS
          break
      }
      switch (useScope) {
        case USE_SCOPE_ENUM.ALL:
          // content = '全场通用(除跨境商品)'
          break
        case USE_SCOPE_ENUM.SPE_CATEGORY:
          content = '指定类目 '
          break
        case USE_SCOPE_ENUM.SPE_GOODS:
          content = '指定商品可用'
          break
        case USE_SCOPE_ENUM.SPE_COUPON:
          content = '指定品牌团'
          break
        case USE_SCOPE_ENUM.SPE_SUBJECT:
          content = '指定专题'
          break
      }
      return content
    },
    /**
     * 倒计时
     */
    startCountDown() {
      setTimeout(() => {
        this.countDownTime--
        if (this.countDownTime > 0) {
          this.startCountDown()
        } else {
          this.showMask = false
        }
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  position: relative;
}
.bless-rewards-wrapper {
  position: relative;
  .reward-bg {
    width: 7.5rem;
    height: 7.84rem;
    background-image: url("../images/yj_recall_1.png");
    background-size: 100%;
  }
  .reward-content {
    width: 4.76rem;
    max-height: 4.4rem;
    overflow-y: auto;
    position: absolute;
    top: 0.7rem;
    left: 50%;
    transform: translateX(-50%);
  }
}
.reward-modal-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1;
}
.reward-modal {
  position: absolute;
  width: 5.56rem;
  height: 6.72rem;
  background-image: url("../images/yj_recall_2.png");
  background-size: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  .reward-modal-content {
    position: relative;
    max-height: 4.4rem;
    overflow-y: auto;
    top: 1.3rem;
  }
  .reward-modal-tip {
    font-size: 0.32rem;
    color: #fffab4;
    letter-spacing: 0;
    text-align: center;
    position: absolute;
    bottom: 0.34rem;
    width: 100%;
  }
}
.reward-item {
  position: relative;
  width: 4.76rem;
  height: 1.2rem;
  background-image: url("../images/yj_recall_3.png");
  background-size: 100%;
  margin: 0 auto 0.2rem;
  color: #ee2532;
  &:last-child {
    margin: 0 auto;
  }
  span {
    display: inline-block;
  }
  .item-price {
    position: relative;
    width: 1.52rem;
    font-size: 0.52rem;
    line-height: 0.52rem;
    text-align: center;
    font-weight: bold;
    top: 50%;
    transform: translateY(-50%);
    .item-price-text {
      position: relative;
      bottom: 0.02rem;
      font-size: 0.24rem;
      line-height: 0.24rem;
    }
  }
  .item-content{
    position: absolute;
    left: 1.7rem;
    top: 50%;
    transform: translateY(-50%);
    .item-title {
      display: block;
      font-size: 0.28rem;
      font-weight: bold;
      overflow: hidden;
      max-height: .7rem;
    }
    .item-desc {
      font-size: 0.24rem;
      display: block;
      margin-top: 0.05rem;
    }
  }
}
</style>
